import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

const url = `${SERVER_API}/chats`;

export const CHAT_ENDPOINTS = {
  GET_CHATS: {
    method: 'GET',
    url,
  } as IEndpointData,
  GET_CHAT(chatId: string): IEndpointData {
    return { method: 'GET', url: `${url}/${chatId}` };
  },
  CREATE_CHAT: {
    method: 'POST',
    url,
  } as IEndpointData,
  GET_MESSAGES(chatId: string): IEndpointData {
    return { method: 'GET', url: `${url}/${chatId}/messages` };
  },
  SEND_MESSAGE(chatId: string): IEndpointData {
    return { method: 'POST', url: `${url}/${chatId}/messages` };
  },
  TOGGLE_PIN(chatId: string): IEndpointData {
    return { method: 'POST', url: `${url}/${chatId}/pin` };
  },
  TOGGLE_MUTE(chatId: string): IEndpointData {
    return { method: 'POST', url: `${url}/${chatId}/mute` };
  },
  ADD_PARTICIPANT(chatId: string): IEndpointData {
    return { method: 'POST', url: `${url}/${chatId}/participant` };
  },
  UPDATE_MESSAGE(chatId: string, messageId: string): IEndpointData {
    return { method: 'PUT', url: `${url}/${chatId}/messages/${messageId}` };
  },
  DELETE_MESSAGE(chatId: string, messageId: string): IEndpointData {
    return { method: 'DELETE', url: `${url}/${chatId}/messages/${messageId}` };
  },
  GET_CHAT_HISTORY(chatId: string): IEndpointData {
    return { method: 'GET', url: `${url}/${chatId}/history` };
  },
};
